import { useEffect, useContext, useState } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import fields from '../fields';
import globalTranslating from '../../../translate.json';
import customerTranslating from '../translate.json';
import usePostData from '../../../hooks/usePostData';
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../../../contexts';
import { isValidIsraeliID, invalidDate } from '../../../utils';

import PropTypes from 'prop-types';

const CreateCustomer = ({ handleAddCustomerToOrg, organizationId }) => {
  const translating = { ...globalTranslating, ...customerTranslating };
  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const { postData, res, error } = usePostData();
  const [errFun, setErrFun] = useState();

  useEffect(() => {
    if (error) {
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    } else if (res) {
      if (res.id) {
        if (handleAddCustomerToOrg) {
          handleAddCustomerToOrg(res);
        } else {
          setLink(null);
          navigate(`/clients?added=true`);
        }
      }
    }
  }, [res, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    if (!isValidIsraeliID(data.ssn))
      setError('ssn', {
        type: 'invalidTZ',
        message: translating.invalidTZ
      });
    else {
      let deepData = { ...data };
      deepData.region = 'כללי';
      deepData.password = 'Pwd12345$';
      deepData.address = `${deepData.city},${deepData.street},${deepData.buildingNumber},${deepData.apartmentNumber},`;
      delete deepData.city;
      delete deepData.street;
      delete deepData.buildingNumber;
      delete deepData.apartmentNumber;
      if (organizationId) deepData.organizationId = organizationId;
      if (deepData.weight === '') deepData.weight = null;
      if (deepData.height === '') deepData.height = null;
      console.log('create client data  :', deepData);
      if (invalidDate(deepData.date_of_birth))
        setError('date_of_birth', {
          type: 'string',
          message: translating.invalidDate
        });
      else {
        deepData.date_of_birth = new Date(deepData.date_of_birth);
        postData('client', deepData, 'post');
      }
    }
  };

  return (
    <div className="create-customer">
      <SectionHeader title={translating.createCustomerTitle}></SectionHeader>
      <FormGroup
        fields={fields(handleAddCustomerToOrg)}
        onSubmit={onSubmit}
        errMsg={error}
      ></FormGroup>
    </div>
  );
};

export default CreateCustomer;

CreateCustomer.propTypes = {
  handleAddCustomerToOrg: PropTypes.func,
  organizationId: PropTypes.number
};
